import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerCmrModalComponent} from './worker-cmr-modal';

export const WorkerCmrModalModule: string = ng
    .module('worker-cmr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerCmrModalComponent', WorkerCmrModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-cmr-modal/worker-cmr-modal.module.ts